import React from 'react'
import { Chip, ChipProps } from '@mui/material'

export type WorkItemStatus = 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED'

interface WorkItemStatusChipProps {
  status: WorkItemStatus
  size?: ChipProps['size']
  variant?: ChipProps['variant']
}

const WorkItemStatusChip: React.FC<WorkItemStatusChipProps> = ({
  status,
  size = 'small',
  variant = 'filled',
}) => {
  const getStatusConfig = (status: WorkItemStatus) => {
    switch (status) {
      case 'PENDING':
        return {
          label: 'Pending',
          color: 'warning' as const,
          backgroundColor: '#fff3e0',
          textColor: '#f57c00',
        }
      case 'IN_PROGRESS':
        return {
          label: 'In Progress',
          color: 'info' as const,
          backgroundColor: '#e1f5fe',
          textColor: '#0277bd',
        }
      case 'COMPLETED':
        return {
          label: 'Completed',
          color: 'success' as const,
          backgroundColor: '#e8f5e8',
          textColor: '#2e7d32',
        }
      case 'CANCELLED':
        return {
          label: 'Cancelled',
          color: 'error' as const,
          backgroundColor: '#ffebee',
          textColor: '#d32f2f',
        }
      default:
        return {
          label: status,
          color: 'default' as const,
          backgroundColor: '#f5f5f5',
          textColor: '#666',
        }
    }
  }

  const config = getStatusConfig(status)

  return (
    <Chip
      label={config.label}
      size={size}
      variant={variant}
      sx={{
        backgroundColor: config.backgroundColor,
        color: config.textColor,
        fontWeight: 'medium',
        '& .MuiChip-label': {
          color: config.textColor,
        },
      }}
    />
  )
}

export default WorkItemStatusChip 